import React from 'react';
//
import WithDirect from './with-direct';
import WithFunction from './with-function';
//
export default React.memo(
  ({ username, use_instagram_black_list }) => {
    if (!username) {
      return null;
    }

    // if (username === 'riffrafffilms') {
    //   return (
    //     <WithFunction
    //       username={username}
    //       use_instagram_black_list={use_instagram_black_list}
    //     />
    //   );
    // }

    return (
      <WithDirect
        username={username}
        use_instagram_black_list={use_instagram_black_list}
      />
    );
  },
  (prev, next) => prev.username === next.username
);
